import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  value: boolean; 
  admin: boolean; 
}

const initialState: AuthState = {
  value: false,
  admin: false
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<boolean>) => {
      state.value = action.payload;
    },
    setAdminAuth: (state, action: PayloadAction<boolean>) => {
      state.admin = action.payload;
    }
  }
});

export const { setAuth, setAdminAuth } = authSlice.actions;
export default authSlice.reducer;